module.exports = __webpack_public_path__ + "img/icon-close-white.b3fd042d.svg";